/** A round axis top at or above x: 1, 2, 2.5, 5 or 10 times a power of ten (2 for x <= 0). */
export function niceCeil(x: number) {
  if (x <= 0) return 2;
  const pow = Math.pow(10, Math.floor(Math.log10(x)));
  const n = x / pow;
  const m = n <= 1 ? 1 : n <= 2 ? 2 : n <= 2.5 ? 2.5 : n <= 5 ? 5 : 10;
  return m * pow;
}
